import { render, staticRenderFns } from "./OpenEnded.vue?vue&type=template&id=dd70a1a4&"
import script from "./OpenEnded.vue?vue&type=script&lang=js&"
export * from "./OpenEnded.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports